import { listEventTimeSlots } from '../../api/listEventTimeSlots/listEventTimeSlots';
import { AsyncComponentDataStatus } from '../../../components/DailyAgenda/state/types';
import { getLocalDateFromDateTime } from '@wix/bookings-catalog-calendar-viewer-utils/dateAndTime';
import type { IHttpError } from '@wix/http-client';
import { InitiatorsArgs } from '../initWidgetData';
import { TriggeredByOptions } from '../../../utils/bi/consts';

export const initAvailableDays = async (
  { flowAPI, setState, getState, biLogger }: InitiatorsArgs,
  triggeredBy: TriggeredByOptions,
) => {
  const { selectedFilters, selectedRange, selectedTimezone } = getState();
  try {
    const { timeSlots } = await listEventTimeSlots({
      flowAPI,
      timeSlotsPerDay: 1,
      limit: 7,
      filters: selectedFilters,
      range: selectedRange,
      timeZone: selectedTimezone,
    });
    if (!timeSlots || timeSlots.length === 0) {
      setState({
        availableDays: {
          status: AsyncComponentDataStatus.ERROR,
          data: 'No available days found',
        },
      });
      biLogger?.reportDatePickerLoad(timeSlots, triggeredBy);
      return;
    }

    const availableDays = timeSlots.map((slot) =>
      getLocalDateFromDateTime(new Date(slot.localStartDate!)),
    );

    // Check if current selected date is in available dates
    const { selectedDate } = getState();
    const currentSelectedDateString = getLocalDateFromDateTime(selectedDate);
    const shouldUpdateSelectedDate = !availableDays.includes(
      currentSelectedDateString,
    );

    setState({
      availableDays: {
        status: AsyncComponentDataStatus.IDLE,
        data: availableDays,
      },
      // Update selected date to first available date if current date is not available
      ...(shouldUpdateSelectedDate &&
        availableDays.length > 0 && {
          selectedDate: new Date(timeSlots[0].localStartDate!),
        }),
    });
  } catch (error) {
    setState({
      availableDays: {
        status: AsyncComponentDataStatus.ERROR,
        data: (error as IHttpError).response?.data,
      },
    });
    console.error('Error initializing available days:', error);
  }
};
